/**
 * La frase inicial de la justificación ("Esta prueba está justificada..." / "Esta prueba no está justificada.")
 * no es editable y se genera según si la prueba está justificada (correct). Solo se edita el contenido (body).
 */

const PREFIX_JUSTIFIED = '<div><div><strong>Esta prueba está justificada.</strong> He aquí los resultados:</div>';
const PREFIX_NOT_JUSTIFIED = '<div><div><strong>Esta prueba no está justificada.</strong></div>';

const PREFIXES_TO_STRIP = [
	'<div><div><strong>Esta prueba está justificada.</strong> He aquí los resultados:</div>',
	'<div><div><strong>Esta prueba está justificada.</strong> He aquí el resultado:</div>',
	'<div><div><strong>Esta prueba no está justificada.</strong></div>',
];

/**
 * Quita la frase inicial del HTML de justificación para mostrar solo la parte editable en el editor.
 * @param {string} html - explanation completo o solo body
 * @returns {string} - solo el contenido editable (body)
 */
export function stripExplanationPrefix(html) {
	if (!html || typeof html !== 'string') return html;
	const trimmed = html.trim();
	for (const prefix of PREFIXES_TO_STRIP) {
		if (trimmed.startsWith(prefix)) {
			return trimmed.slice(prefix.length).trim();
		}
	}
	return html;
}

/**
 * Añade la frase inicial al body para guardar o mostrar. Usar al guardar si queremos normalizar a body-only.
 * No se usa actualmente al guardar: guardamos lo que hay en el editor (que ya es body tras strip al abrir).
 */
export function buildFullExplanation(body, isJustified) {
	const prefix = isJustified ? PREFIX_JUSTIFIED : PREFIX_NOT_JUSTIFIED;
	const b = (body || '').trim();
	return b ? prefix + b : prefix;
}
